import * as React from "react";

import { DefaultColumn, TableColumn, TableDtRefColumn } from "./DefaultColumn/DefaultColumn";
import { resolveFieldData } from "../../../helpers/utils/FieldDataResolver";


export const NumberColumn: React.FC<TableDtRefColumn> = (c) => {
  const bodyTemplate = (rowData :any, col: any) => {
    const val = resolveFieldData(rowData, col.field);
    return <span>{typeof val === `number` ? val.toLocaleString(`ru-RU`, { minimumFractionDigits: 2 }) : val}</span>
  }

  return DefaultColumn({
    bodyClassName: `pda-column-number ${c.bodyClassName ?? ``}`,
    headerClassName: `pda-column-number-header ${c.headerClassName ?? ``}`,
    body: bodyTemplate,
    ...c,
  });
};
